import { Pipe, PipeTransform } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';

/**
 * Generated class for the StorageUrlPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'storageUrl',
})
export class StorageUrlPipe implements PipeTransform {

  constructor(
    private storage: AngularFireStorage
  ) {
  }
  transform(value: any, arg: any) {
    return new Promise<any>((resolve, reject) => {
          // console.log("value",value);
          // console.log("arg",arg);
          if ((value != null) && (value!= '')){
            if(value.indexOf('../assets') !== -1){
              resolve(value);
            }
            else if(this.isUrl(value)){
              resolve(value);
            }
            else if(this.isDataURL(value)){
              resolve(value);
            }
            else{
              this.storage.ref(value).getDownloadURL().subscribe(url=>{
                resolve(url);
              });
            }
          }
        });
  }

  isUrl(url){
    var pattern = /^((http|https|ftp):\/\/)/;
    if(!pattern.test(url))
       return false;
    else
      return true;
  
  }

  isDataURL(s) {
    let regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
    return !!s.match(regex);
  }


  
  //   
  // }

  // getDownloadLink(value){
  //   console.log("getDownloadLink");
  //   return this.storage.ref(value).getDownloadURL().subscribe(url=>{
  //     console.log("getDownloadLink result", url);
  //     return this.transform(null, url);
  //   });
  // }
}


// WEBPACK FOOTER //
// ./src/pipes/storage-url/storage-url.ts